// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__25aQY","messages":"Chat_messages__15gVM","dateDivider":"Chat_dateDivider__2vILh"};